import { Autocomplete } from '@/components/inputs/Autocomplete/Autocomplete'

import { TypeOption } from '../types'

type ActionTypeSelectorProps = {
  value: TypeOption[]
  onChange: (value: TypeOption[]) => void
  options?: TypeOption[]
  disabled?: boolean
}

const defaultActionTypeOptions: TypeOption[] = [{ value: 'Odds Update', label: 'Odds Update' }]

export const ActionTypeSelector = ({
  value,
  onChange,
  options = defaultActionTypeOptions,
  disabled = false
}: ActionTypeSelectorProps) => {
  return (
    <Autocomplete
      label="Action Type"
      options={options}
      value={value}
      onChange={(newValue) => onChange(newValue || [])}
      getOptionLabel={(option) => option.label}
      disabled={disabled}
      multiselect
    />
  )
}
